import {
  ListManager, PageHeader, Paginator, Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import clinicalCareClassifications from '@/services/api/clinicalCareClassifications'
import React, { useCallback } from 'react'
import FormClassification from './components/Form'
import Row from './components/Row'

function Classifications({ title }) {
  usePageTitle({ title })
  const query = useQuery()

  const {
    loading, data, error, fetchData, setData,
  } = useAxiosRequest(clinicalCareClassifications.list, query)

  const onClassificationRemoved = useCallback((classification) => {
    setData((oldData) => ({
      ...oldData,
      rows: oldData.rows.filter((c) => c.id !== classification.id),
      count: oldData.count - 1,
    }))
  }, [setData])

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Classificações de atendimentos clínicos"
        icon="fas fa-tags"
        subtitle="Listagem das classificações que podem ser selecionadas pelo cidadão ao solicitar atendimento clínico."
        rightAction={() => (
          <FormClassification btnClass="btn btn-primary" btnIcon="fas fa-plus" btnText="Adicionar" onApiResponse={fetchData} />
        )}
      />
      <ListManager loading={loading} count={data?.count || 0} error={error}>
        {
          Boolean(data) && (
            <div>
              <small>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Descrição</th>
                      <th width="200px">Prioridade</th>
                      <th className="text-right" width="80px">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      data.rows.map((classification) => (
                        <Row
                          key={classification.id}
                          classification={classification}
                          fetchData={fetchData}
                          onClassificationRemoved={onClassificationRemoved}
                        />
                      ))
                    }
                  </tbody>
                </table>
              </small>
              {
                Boolean(data) && (
                  <div className="my-2">
                    <Paginator paginatedList={data} />
                  </div>
                )
              }
            </div>
          )
        }
      </ListManager>
    </Styles.Container>
  )
}

export default Classifications
